import './index.scss';
import './assets/fonts/stylesheet.css';
import './icons.css';
import App from './App';
import { LoginContextProvider } from './store/login-context';
import * as serviceWorker from './serviceWorker';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <LoginContextProvider>
        <App />
    </LoginContextProvider>    
);

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

